"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skycover = exports.circle = exports.pie = exports.DEFAULT_Y = exports.DEFAULT_X = exports.BASE_RADIUS = void 0;
var BASE_RADIUS = 0.9;
exports.BASE_RADIUS = BASE_RADIUS;
var DEFAULT_X = 22;
exports.DEFAULT_X = DEFAULT_X;
var DEFAULT_Y = 22;
/*
 * Builds the sky cover symbol for sky obscured
 */

exports.DEFAULT_Y = DEFAULT_Y;

var obscured = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.x,
      x = _c === void 0 ? DEFAULT_X : _c,
      _d = _b.y,
      y = _d === void 0 ? DEFAULT_Y : _d,
      _e = _b.radius,
      radius = _e === void 0 ? BASE_RADIUS * 2 : _e,
      _f = _b.fill,
      fill = _f === void 0 ? 'transparent' : _f,
      _g = _b.rotation,
      rotation = _g === void 0 ? -90 : _g,
      _h = _b.strokeWidth,
      strokeWidth = _h === void 0 ? 0.5 : _h,
      _j = _b.strokeColor,
      strokeColor = _j === void 0 ? 'black' : _j;

  var x1 = x - radius;
  var x2 = x + radius;
  return "<line\n\t\tx1=\"" + x1 + "\"\n\t\tx2=\"" + x2 + "\"\n\t\ty1=\"" + y + "\"\n\t\ty2=\"" + y + "\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\ttransform=\"rotate(-45 " + x + " " + y + ")\"/>\n\t\t<line\n\t\tx1=\"" + x1 + "\"\n\t\tx2=\"" + x2 + "\"\n\t\ty1=\"" + y + "\"\n\t\ty2=\"" + y + "\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\ttransform=\"rotate(45 " + x + " " + y + ")\"\n\t/>";
};
/*
 * Builds the sky cover symbol for "missing"
 */


var missing = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.strokeWidth,
      strokeWidth = _c === void 0 ? 0.5 : _c,
      _d = _b.strokeColor,
      strokeColor = _d === void 0 ? 'black' : _d;

  return "\n\t<line\n\t\tx1=\"11.25\"\n\t\tx2=\"11\"\n\t\ty1=\"10.5\"\n\t\ty2=\"13.5\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\tstroke-linecap=\"round\"\n\t/>\n\t<line\n\t\tx1=\"11.25\"\n\t\tx2=\"12\"\n\t\ty1=\"10.5\"\n\t\ty2=\"12.5\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\tstroke-linecap=\"round\"\n\t/>\n\t<line\n\t\tx1=\"12.75\"\n\t\tx2=\"12\"\n\t\ty1=\"10.5\"\n\t\ty2=\"12.5\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\tstroke-linecap=\"round\"\n\t/>\n\t<line\n\t\tx1=\"12.75\"\n\t\tx2=\"13\"\n\t\ty1=\"10.5\"\n\t\ty2=\"13.5\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\tstroke-linecap=\"round\"\n\t/>\n";
};
/*
 * Builds the pie symbol representing the amount of sky coverage there is.
 */


var pie = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.x,
      x = _c === void 0 ? DEFAULT_X : _c,
      _d = _b.y,
      y = _d === void 0 ? DEFAULT_Y : _d,
      _e = _b.radius,
      radius = _e === void 0 ? BASE_RADIUS : _e,
      _f = _b.fill,
      fill = _f === void 0 ? 'transparent' : _f,
      _g = _b.rotation,
      rotation = _g === void 0 ? -90 : _g,
      _h = _b.strokeWidth,
      strokeWidth = _h === void 0 ? BASE_RADIUS * 2 : _h,
      _j = _b.strokeColor,
      strokeColor = _j === void 0 ? 'black' : _j,
      _k = _b.fillPercentage,
      fillPercentage = _k === void 0 ? 1 : _k;

  return "\n\t<circle\n\t\tcx=\"" + x + "\"\n\t\tcy=\"" + y + "\"\n\t\tr=\"" + radius + "\"\n\t\tfill=\"" + fill + "\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t\tstroke-dasharray=\"" + 2 * Math.PI * radius * fillPercentage + " " + 2 * Math.PI * radius + "\"\n\t\ttransform=\"rotate(" + rotation + " " + x + " " + y + ")\"\n\t/>\n";
};
/*
 * Builds the backing circle of the sky cover symbol
 */


exports.pie = pie;

var circle = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.x,
      x = _c === void 0 ? DEFAULT_X : _c,
      _d = _b.y,
      y = _d === void 0 ? DEFAULT_Y : _d,
      _e = _b.radius,
      radius = _e === void 0 ? BASE_RADIUS * 2 : _e,
      _f = _b.fill,
      fill = _f === void 0 ? 'white' : _f,
      _g = _b.strokeWidth,
      strokeWidth = _g === void 0 ? 0.5 : _g,
      _h = _b.strokeColor,
      strokeColor = _h === void 0 ? 'black' : _h;

  return "\n\t<circle\n\t\tcx=\"" + x + "\"\n\t\tcy=\"" + y + "\"\n\t\tr=\"" + radius + "\"\n\t\tfill=\"" + fill + "\"\n\t\tstroke=\"#ffffff\"\n\t\tstroke-width=\"" + (strokeWidth + 1.5) + "\"\n\t/>\n\t<circle\n\t\tcx=\"" + x + "\"\n\t\tcy=\"" + y + "\"\n\t\tr=\"" + radius + "\"\n\t\tfill=\"" + fill + "\"\n\t\tstroke=\"#000000\"\n\t\tstroke-width=\"" + (strokeWidth + 0.5) + "\"\n\t/>\n\t<circle\n\t\tcx=\"" + x + "\"\n\t\tcy=\"" + y + "\"\n\t\tr=\"" + radius + "\"\n\t\tfill=\"" + fill + "\"\n\t\tstroke=\"" + strokeColor + "\"\n\t\tstroke-width=\"" + strokeWidth + "\"\n\t/>\n";
};
/*
 * Builds the hand of the wind barb.
 */


exports.circle = circle;

var hand = function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.x1,
      x1 = _c === void 0 ? DEFAULT_X : _c,
      _d = _b.y1,
      y1 = _d === void 0 ? DEFAULT_X - BASE_RADIUS * 2 : _d,
      _e = _b.x2,
      x2 = _e === void 0 ? DEFAULT_Y : _e,
      _f = _b.y2,
      y2 = _f === void 0 ? DEFAULT_Y + BASE_RADIUS * 2 : _f,
      _g = _b.strokeColor,
      strokeColor = _g === void 0 ? "black" : _g,
      _h = _b.strokeWidth,
      strokeWidth = _h === void 0 ? 0.75 : _h,
      _j = _b.rotation,
      rotation = _j === void 0 ? 0 : _j;

  var centerX = x2 - Math.abs((x2 - x1) / 2);
  var centerY = y2 - Math.abs((y2 - y1) / 2);
  return "\n\t\t<line\n\t\t\tx1=\"" + x1 + "\"\n\t\t\ty1=\"" + y1 + "\"\n\t\t\tx2=\"" + x2 + "\"\n\t\t\ty2=\"" + y2 + "\"\n\t\t\tstroke=\"" + strokeColor + "\"\n\t\t\tstroke-width=\"" + strokeWidth + "\"\n\t\t\ttransform=\"rotate(" + rotation + " " + centerX + " " + centerY + ")\"\n\t\t/>\n\t";
};

var symbols = {
  missing: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + missing({
      strokeColor: color
    }) + "\n\t";
  },
  0: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t";
  },
  1: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + hand({
      strokeColor: color
    }) + "\n\t";
  },
  2: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t";
  },
  3: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color,
      fillPercentage: 0.25
    }) + "\n\t\t" + hand({
      strokeColor: color
    }) + "\n\t";
  },
  4: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color,
      fillPercentage: 0.5
    }) + "\n\t";
  },
  5: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color,
      fillPercentage: 0.5
    }) + "\n\t\t" + hand({
      strokeColor: color,
      rotation: 90
    }) + "\n\t";
  },
  6: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color,
      fillPercentage: 0.75
    }) + "\n\t";
  },
  7: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color
    }) + "\n\t\t" + hand({
      strokeColor: '#ffffff'
    }) + "\n\t";
  },
  8: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + pie({
      strokeColor: color
    }) + "\n\t";
  },
  9: function (color) {
    return "\n\t\t" + circle({
      strokeColor: color
    }) + "\n\t\t" + obscured({
      strokeColor: color
    }) + "\n\t";
  }
};

var skycover = function (code, color) {
  if (color === void 0) {
    color = '#000';
  }

  if (symbols[code]) {
    return symbols[code](color);
  }

  return symbols.missing(color);
};

exports.skycover = skycover;